module.exports = __webpack_public_path__ + "static/media/tasaday.68df6b76.jpg";